import React from "react";
import SitesList from "../component/SitesList";

const SitesListContainer = () => (<SitesList />)

export default SitesListContainer;
